export default "__VITE_ASSET__2JPnR_4f__"